<div class="card">
    <div class="card-header">
        <app-cierre-nav-bar></app-cierre-nav-bar>
    </div>

    @switch (this.stepActual.label) {
        @case ('Etapa 1: Realizar cierre') { 
            <app-realizar-cierre-turno></app-realizar-cierre-turno> 
        }
        @case ('Etapa 2: Carga de datos') { 
            <app-carga-datos-cierre-turno></app-carga-datos-cierre-turno> 
        }
        @case ('Etapa 3: Cuadros de comparativas') { 
            <app-comparativas-cierre-turno></app-comparativas-cierre-turno> 
        }
        @case ('Etapa 4: Parte diario') {
            <app-parte-diario-cierre-turno></app-parte-diario-cierre-turno>
        }
        @case ('Finalizar Turno') {
            <label style="margin-left: 1em;">
                <h5><b>El cierre de turno se finalizó correctamente, puede verificar los datos en la pestaña reportes.</b>
                </h5>
            </label>
        }
    }

</div>